<template>
  <div class="text-center">
    <v-card class="list-area-box">
      <v-list class="list-area">
        <v-list-item>
          <v-list-item-title>대상자</v-list-item-title>
          <v-list-item-subtitle> {{ famRshipCd }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>대상자명</v-list-item-title>
          <v-list-item-subtitle> {{ tgtName }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>실접종비</v-list-item-title>
          <v-list-item-subtitle>
            {{ Number(realAmnt).toLocaleString() }}원
          </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>신청금액</v-list-item-title>
          <v-list-item-subtitle>
            {{ Number(applAmnt).toLocaleString() }}원
          </v-list-item-subtitle>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
</template>
<script>
import { getVaccinationDetail } from '@/api/workStatus';
import { mapMutations, mapGetters } from 'vuex';
import { getUiInfo } from '@/api/approvalCommon';

export default {
  data: () => ({
    tgtName: '',
    realAmnt: '',
    applAmnt: '',
    famRshipCd: '',
  }),
  props: {
    appInfoParam: Object,
  },
  computed: {
    ...mapGetters(['GET_SEQ_NO']),
    scrollViewStyle() {
      return `max-height: ${
        window.innerHeight - this.$store.getters.HEIGHT_BOTTOM_NAV
      }px`;
    },
  },

  methods: {
    ...mapMutations('SPINNER', ['ON_APP_SPINNER', 'OFF_APP_SPINNER']),
  },

  async created() {
    this.appInfoParam.seqNo = this.GET_SEQ_NO === '' ? 1 : this.GET_SEQ_NO;
    let response = await getVaccinationDetail(this.appInfoParam);

    this.famRshipCd = response.data.data.famRshipCd;
    if ('SE' === this.famRshipCd) {
      this.famRshipCd = '본인';
    } else if ('SP' === this.famRshipCd) {
      this.famRshipCd = '배우자';
    }
    this.tgtName = response.data.data.tgtName;
    this.realAmnt = response.data.data.realAmnt;
    this.applAmnt = response.data.data.applAmnt;

    response = await getUiInfo(this.appInfoParam);
    console.dir(response);

    if (response.data.data.fileYn === 'N') {
      this.$emit('showFileView', false);
    } else {
      this.$emit('showFileView', true);
    }

    this.OFF_APP_SPINNER();
  },

  components: {},
};
</script>
